const TEMPLATE_PRODUCTS: readonly string[] = [
	'atlassian-studio',
	'jira',
	'jira-service-management',
	'confluence',
];

const DEFAULT_TEMPLATE_PRODUCT = 'atlassian-studio';

/**
 * Agent templates are published against a fixed set of product surfaces. Hosts that embed the
 * browse agents modal outside those products still pass their own product (Rovo Chat sends its
 * `rovo` product header), which matches no templates at all — so they read the Studio set and get
 * generic templates instead of an empty Remix section.
 */
export const resolveTemplateProduct = (product?: string): string =>
	product && TEMPLATE_PRODUCTS.includes(product) ? product : DEFAULT_TEMPLATE_PRODUCT;
